import {
  CREATE_RANDOM_MESSAGE,
  CREATE_TEACHER,
  DELETE_TEACHER,
  GET_RANDOM_MESSAGES,
  GET_TEACHERS,
  REMOVE_RANDOM_MESSAGE,
  UPDATE_TEACHER_MESSAGE,
} from "../../constants/apiUrls";
import { fetchData } from "../../shared/fetchData";
import actionTypes from "./actionTypes";
import Locale from "../../locales";

export const adminRequestStart = () => {
  return {
    type: actionTypes.ADMIN_REQUEST_START,
  };
};

export const adminRequestSuccess = (message) => {
  return {
    type: actionTypes.ADMIN_REQUEST_SUCCESS,
    data: message,
  };
};

export const adminRequestFail = (errMessage) => {
  return {
    type: actionTypes.ADMIN_REQUEST_FAIL,
    data: errMessage,
  };
};

export const clearAdminSuccess = () => {
  return {
    type: actionTypes.CLEAR_ADMIN_SUCCESS,
  };
};

export const clearAdminError = () => {
  return {
    type: actionTypes.CLEAR_ADMIN_ERROR,
  };
};

export const clearAdminState = () => {
  return {
    type: actionTypes.CLEAR_ADMIN_REDUCER_STATE,
  };
};

export const getTeachers = () => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      GET_TEACHERS,
      {},
      (res) => {
        dispatch(adminRequestSuccess(Locale.t("teachers_loaded")));
        const teachers = res.teachers.filter(
          (teacher) => teacher.role !== "admin",
        );
        dispatch({ type: actionTypes.GET_TEACHERS, data: teachers });
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
  };
};

export const addTeacher = (emailId) => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      CREATE_TEACHER,
      { emailId },
      () => {
        dispatch(adminRequestSuccess(Locale.t("teacher_added")));
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
    dispatch({ type: actionTypes.ADD_TEACHER, data: emailId });
  };
};

export const deleteTeacher = (emailId) => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      DELETE_TEACHER,
      { emailId },
      () => {
        dispatch(adminRequestSuccess(Locale.t("teacher_removed")));
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
    dispatch({ type: actionTypes.DELETE_TEACHER, data: emailId });
  };
};

export const updateTeacher = (emailId, newEmailId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_TEACHER,
      emailId,
      newEmailId,
    });
  };
};

export const createCustomMessages = (fromRange, toRange, message) => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      CREATE_RANDOM_MESSAGE,
      { fromRange, toRange, message },
      () => {
        dispatch(adminRequestSuccess(Locale.t("message_added")));
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
  };
};

export const fetchCustomMessages = (fromRange, toRange) => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      GET_RANDOM_MESSAGES,
      { fromRange, toRange },
      (res) => {
        dispatch(adminRequestSuccess(Locale.t("messages_fetched")));
        dispatch({ type: actionTypes.GET_CUSTOM_MESSAGES, data: res.messages });
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
  };
};

export const removeRandomMessage = (referenceId) => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      REMOVE_RANDOM_MESSAGE,
      { referenceId },
      () => {
        dispatch(adminRequestSuccess(Locale.t("message_removed")));
        dispatch({
          type: actionTypes.REMOVE_RANDOM_MESSAGE,
          data: referenceId,
        });
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
  };
};

export const updateTeacherMessage = (data) => {
  return (dispatch) => {
    dispatch(adminRequestStart());
    fetchData(
      "POST",
      UPDATE_TEACHER_MESSAGE,
      { ...data },
      () => {
        dispatch(adminRequestSuccess(Locale.t("message_updated")));
        dispatch({ type: actionTypes.UPDATE_TEACHER_MESSAGE, data });
      },
      (err) => {
        dispatch(adminRequestFail(err.message));
      },
    );
  };
};
